/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import LoyaltySignUp from './loyalty-sign-up';
import LoyaltySignUpView from './loyalty-sign-up.view';

export * from './loyalty-sign-up';
export * from './loyalty-sign-up.data';
export { ILoyaltySignUpConfig, ILoyaltySignUpProps, ILoyaltySignUpResources, IMemberHeadingData, MemberHeadingTag } from './loyalty-sign-up.props.autogenerated';
export * from './loyalty-sign-up.view';

export {
    LoyaltySignUp,
    LoyaltySignUpView
};
